import { captureException } from "@sentry/react";
import { registerPushNotifications } from "@services/backend";
import React, { useEffect } from "react";
import { useAuthContext } from "./AuthContext";
import { storageKeys } from "./constants";
import { getPushSub, isPushApiSupported, minsToMs } from "./utils";

const SwSetup: React.FC = () => {
  const auth = useAuthContext();

  // const currentSettings = {
  // enablePushRegistration: true,
  // vapPub: import.meta.env.VITE_VPUB,
  // };

  useEffect(() => {
    if (!isPushApiSupported() || !auth.is_member) return;
    navigator.serviceWorker.register("/sw.js").catch(function (error) {
      console.error("sw.reg failed:", error);
      captureException(error, { extra: { at: "sw.reg" } });
    });

    // don't setup periodic refreshes if user notif perm not granted or pushsub cookie not set
    // the pushsub cookie is usually set when user manually enables push notifications [in registerPushNotifications()].
    if (Notification.permission !== "granted" || !getPushSub()) {
      return;
    }

    // ^^ alternatively we can set the interval anyway, but do the getPushSub() check here
    // but it's probably better to not set the interval, to reduce background tasks.
    // that would mean if user enables notifications, they'd have to refresh the page once for this to kick off again.
    const refresh = async () => {
      if (!getPushSub()) return;
      registerPushNotifications(false).catch((err) => {
        captureException(err, { extra: { at: "sw.interval" } });
      });
    };
    const intervalId = setInterval(() => refresh(), minsToMs(720));

    // refresh now if needed
    setTimeout(() => {
      const prev = Number(localStorage.getItem(storageKeys.pushsubrefreshed));
      if (!prev || Date.now() - prev > minsToMs(720)) {
        refresh();
      }
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [auth.is_member]);

  return null;
};

export default SwSetup;
